import React from 'react';
import styled from 'styled-components';
import SearchResultsEmptyState from '../SearchPage/SearchResultsEmptyState';
import SearchResults from '../SearchPage/SearchResults';
import { MaxWidthLayoutDesktop } from '../../../templates/MaxWidthLayout';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const SearchResultsWrapperDiv = styled.div`
  margin: 0 ${p => p.theme.unit(2)} ${p => p.theme.unit(5)} ${p => p.theme.unit(2)};
`;

const MobileSearchResultsWrapperDiv = styled.div`
  margin: 0 ${p => p.theme.unit(3)} ${p => p.theme.unit(5)} ${p => p.theme.unit(3)};
`;

const SearchResultCountSpan = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${p => p.theme.c.text.primary};
  display: block;
`;

const SearchQueryH1 = styled.h1`
  margin: 0;
  margin-top: ${p => p.theme.unit(1)};
`;

const SearchQueryString = styled.span`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
`;

const ScreenReaderOnlySpan = styled.span`
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
`;

const SearchResultsContainer = (props) => {

  const {
    shopHits,
    categoryHits,
    searchNavBarData,
    searchPageData,
    totalNumberOfHits,
    searchQuery,
    locale,
    pageStateModifiers,
    userData,
  } = props;

  const {
    resultsForText = '',
    displayName = '',
  } = searchPageData;

  const SearchContentToUse = () => {
    if (totalNumberOfHits > 0) {
      return (
        <SearchResults
          {...searchNavBarData}
          locale={locale}
          shopHits={shopHits}
          categoryHits={categoryHits}
          pageStateModifiers={pageStateModifiers}
          userData={userData}
      />);
    }
    return (
      <SearchResultsEmptyState
        searchQuery={searchQuery}
        locale={locale}
        {...searchPageData} />
    );
  };

  const DesktopBody = () => (
    <MaxWidthLayoutDesktop>
      <SearchResultsWrapperDiv>
        <SearchQueryH1>
          <SearchResultCountSpan>
            { totalNumberOfHits } <ScreenReaderOnlySpan>{displayName}</ScreenReaderOnlySpan> { resultsForText }
          </SearchResultCountSpan>
          <SearchQueryString>{searchQuery}</SearchQueryString>
        </SearchQueryH1>
        <SearchContentToUse />
      </SearchResultsWrapperDiv>
    </MaxWidthLayoutDesktop>
  );

  const MobileBody = () => (
    <MobileSearchResultsWrapperDiv>
      <SearchQueryH1 isMobile>
        <SearchResultCountSpan>
          { totalNumberOfHits } <ScreenReaderOnlySpan>{displayName}</ScreenReaderOnlySpan> { resultsForText }
        </SearchResultCountSpan>
        <SearchQueryString>{searchQuery}</SearchQueryString>
      </SearchQueryH1>
      <SearchContentToUse />
    </MobileSearchResultsWrapperDiv>
  );

  const renderComp = totalNumberOfHits !== null ? (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />) : null;

  return renderComp;

};

export default SearchResultsContainer;
